'use strict';
module.exports = {
    NODE_ENV: '"production"'
};
